// @ts-nocheck
import React from 'react'

const normaliseDateForInput = (value) => {
    const rawValue = String(value ?? '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) return rawValue;

    const europeanDate = rawValue.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    return europeanDate ? `${europeanDate[3]}-${europeanDate[2]}-${europeanDate[1]}` : '';
};

const Datepicker = ({ required, label, id, value, onInputChange }) => {
    const handleInputChange = event => {
        const selectedDate = event.target.value;

        if (!selectedDate) {
            onInputChange(label, '');
            return;
        }

        const [year, month, day] = selectedDate.split('-');
        const dateToSave = `${day}-${month}-${year}`;
        onInputChange(label, selectedDate, { serializedValue: dateToSave });
    };
    return (
        <div className="mb-6">
            <label htmlFor={`date-${id}`} className="mb-2 block text-sm font-semibold text-slate-800"><span data-i18n-ignore="true">{label}</span>
            {required && <span className="text-red-500"> *</span>}
            </label>
            <input
                type="date"
                id={`date-${id}`}
                className="block h-12 w-full rounded-xl border border-slate-300 bg-slate-50/60 px-4 text-sm text-slate-900 shadow-sm transition hover:border-slate-400 focus:border-emerald-600 focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-100" value={normaliseDateForInput(value)}
                onChange={handleInputChange}
                onInput={handleInputChange}
                required={required}
                aria-describedby={`date-help-${id}`}
            />
            <p id={`date-help-${id}`} className="mt-1 text-xs text-slate-500">Seleciona uma data no calendário.</p>
        </div>
    );
}

export default Datepicker;
